<template>
  <div class="template">
    <WordpressDesktop class="template__Desktop" />
    <WordpressMobile class="template__Mobile" />
  </div>
</template>

<script>
import WordpressMobile from '@/components/services/Wordpress/WordpressMobile.vue'
import WordpressDesktop from '@/components/services/Wordpress/WordpressDesktop.vue'
export default {
  name: 'WordpressView',
  components: {
    WordpressDesktop,
    WordpressMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>